var StandingStore = /** @class */ (function () {
    function StandingStore() {
        var state = {};
        this.store = {
            getItem: function (key) { return state[key] || null; },
            setItem: function (key, val) {
                state[key] = val;
            },
            removeItem: function (key) {
                delete state[key];
            },
        };
    }
    StandingStore.prototype.setStore = function (newStore) {
        this.store = newStore;
    };
    StandingStore.prototype.getItem = function (key) {
        var _a;
        if (!((_a = this.store) === null || _a === void 0 ? void 0 : _a.getItem)) {
            return null;
        }
        return this.store.getItem(key) || null;
    };
    StandingStore.prototype.setItem = function (key, value) {
        var _a;
        if (!((_a = this.store) === null || _a === void 0 ? void 0 : _a.setItem)) {
            return;
        }
        this.store.setItem(key, value);
    };
    StandingStore.prototype.removeItem = function (key) {
        var _a;
        if (!((_a = this.store) === null || _a === void 0 ? void 0 : _a.removeItem)) {
            return;
        }
        this.store.removeItem(key);
    };
    return StandingStore;
}());
export default new StandingStore();
//# sourceMappingURL=index.js.map